module.exports = "## Toolbars\n\nToolbars are collections of components stacked horizontally against each other.\nToolbars provide greater versatility than AppBars which are a subset of toolbars.\nThe following toolbar components can help organize your layout.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/Toolbars/README.md
 ** module id = 892
 ** module chunks = 0
 **/